import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import AssignmentDetailCard from '../AssignmentDetailCard/AssignmentDetailCard';

const styles = (theme) => ({});

class UpcomingAssignmentDetailView extends Component {
    render() {
        const { assignment, assignmentTeam } = this.props;

        return !assignment ? (
            <p>Error, Assignment not found</p>
        ) : (
            <AssignmentDetailCard
                assignment={assignment}
                type="upcoming"
                assignmentTeam={assignmentTeam}
            />
        );
    }
}

export default withStyles(styles)(UpcomingAssignmentDetailView);
